import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { SdProxyVoteComponent } from '../../sd-proxy-vote/sd-proxy-vote.component';
import { DateFormatPipe } from '../../../../../controls/pipes/date-format.pipe';
import { ISdVoteDto } from '../../../../shared/models/sd/sd-vote';

@Component({
    selector: 'app-sd-history-column',
    templateUrl: './sd-history-column.component.html',
    styleUrl: './sd-history-column.component.scss',
    standalone: false
})
export class SdHistoryColumnComponent {
  @Input() vote: ISdVoteDto | null = null;
  @Input() isUserPmOrAboveOrHoSD: boolean = false;
  @Input() afterSaveSubject: Subject<string> = new Subject<string>();

  isEligible: boolean = false;
  lastUpdated: string = '';

    constructor(
      private _modalService: NgbModal,
      private dateFormatPipe: DateFormatPipe
    ) {}

  ngOnInit(): void {
    if (this.vote && this.vote.lastUpdated) {
      this.isEligible = this.vote.isEligible;
      this.lastUpdated = this.dateFormatPipe.transform(this.vote.lastUpdated);
    }
  }


  openProxyVoteModal() {
    const modalRef = this._modalService.open(SdProxyVoteComponent, { size: 'lg', centered: true });
    modalRef.componentInstance.voteData = this.vote;
    modalRef.result.then(r => {
      if(r) {
        this.afterSaveSubject.next(r);
      }
    })
  }

}
